var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "table-bar",
      attrs: { "aria-label": _vm.$t("Tài Xỉu table selector") },
    },
    [
      _c("DiceLauncher", {
        staticClass: "table-bar__identity",
        attrs: { active: "" },
        on: {
          click: function ($event) {
            return _vm.$emit("close")
          },
        },
      }),
      _c("TableChips", {
        staticClass: "table-bar__tables",
        attrs: { tables: _vm.tables, "is-active": _vm.isActive },
        on: {
          select: function ($event) {
            return _vm.$emit("select-table", $event)
          },
        },
      }),
      _c("label", { staticClass: "quick-toggle" }, [
        _c("input", {
          attrs: { type: "checkbox" },
          domProps: { checked: _vm.quickPlayEnabled },
          on: { change: _vm.toggleQuickPlay },
        }),
        _c("i", { attrs: { "aria-hidden": "true" } }),
        _c("span", [_vm._v(_vm._s(_vm.$t("Quickplay")))]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }